//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QueryFilter from './QueryFilter';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "DateQueryFilter",
	computed: {
        ...mapGetters(['getStartDate', 'getEndDate', 'getYears']),
        startDate: {
            get() {
                return this.getStartDate === null ? '...' : this.getStartDate.getFullYear();
            },
            set(value) {
                this.yearSelected(value, true);
            }
        },
        endDate: {
            get() {
                return this.getEndDate === null ? '...' : this.getEndDate.getFullYear();
            },
            set(value) {
                this.yearSelected(value, false);
            }
        }
    },
    methods: {
        ...mapActions(['setDate']),
        yearSelected: function(year, start = true) {
            let date = null;
            if(year !== '...')
                date = start ? new Date(year, 0, 1) : new Date(year, 11, 31, 23, 59, 59);

            this.setDate({ date: date, start: start });
        }
    }
};
